// frontend/src/components/Timer/Timer.js

import React from 'react';

const Timer = ({ currentTime }) => {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
      .toString()
      .padStart(2, '0');
    const secs = (seconds % 60).toString().padStart(2, '0');
    return `${mins}:${secs}`;
  };

  return (
    <div className="timer">
      {formatTime(currentTime)}
    </div>
  );
};

export default Timer;
